module.exports = __webpack_public_path__ + "img/reference-fsd-automobile.5319dacc.webp";